<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons" *ngIf="dataLoaded">{{title}}</h4>
</div>
<div class="modal-body">
    <div class="spinner" *ngIf="!dataLoaded"></div>
    <ng-container *ngIf="dataLoaded">
        <search-results [context]="data.context" [results]="results" [searchString]="searchString" (onItemSelected)="itemSelected($event)"></search-results>
    </ng-container>
</div>
